export const LADE_AUSWAHLWERTE_ZAHLUNGSEINGANG = "ladeAuswahlwerteZahlungseingang";